import { LOCATION_REQUIREMENT_REF_PREFIX } from './requirementRef.util'

// "location:<id>" is this domain's own sentinel prefix — distinct from group requirements'
// "group:<id>" — so a raw policyBody value is unambiguous about which kind of requirement it
// diverts to, without needing to know which field it came from.
export const REQUIREMENT_REF_PREFIX = LOCATION_REQUIREMENT_REF_PREFIX

export const isRequirementRef = (value) => typeof value === 'string' && value.startsWith(REQUIREMENT_REF_PREFIX)

export const getRequirementId = (value) => (isRequirementRef(value) ? value.slice(REQUIREMENT_REF_PREFIX.length) : null)

export const toRequirementRef = (requirementId) => `${REQUIREMENT_REF_PREFIX}${requirementId}`

// Graph's own wildcard location values (mirrors policy_management/constants.js's BASE_LOCATIONS /
// BASE_INCLUDE_LOCATIONS) — these need no named location to exist and never go through
// resolution, so a field auto-resolved via a requirement must still accept them as literal values
// rather than treating every typed entry as "define a new named location requirement".
export const BUILT_IN_LOCATION_VALUES = ['All', 'AllTrusted']

export const isBuiltInLocationValue = (value) => BUILT_IN_LOCATION_VALUES.includes(value)

// Mirrors backend/src/lambdas/service/hub/microsoft/namedLocationRequirements/
// resolveNamedLocationRequirements.js's RESOLUTION_STATUS.
export const NAMED_LOCATION_REQUIREMENT_STATUS = {
  MATCHED: 'matched',
  CREATABLE: 'creatable',
  MULTI_MATCH: 'multiMatch',
  UNRESOLVABLE: 'unresolvable',
}

// Mirrors named_locations/constants.js's NAMED_LOCATION_TYPES (hub-side, uppercase) — distinct
// from policy_named_locations/constants.js's UI-facing camelCase values, since a requirement
// definition crosses the wire to the backend resolver as-is.
export const NAMED_LOCATION_REQUIREMENT_TYPES = {
  RISKY_IP: 'RISKY_IP',
  RISKY_COUNTRY: 'RISKY_COUNTRY',
}

// Mirrors backend's resolveAndBindNamedLocationsForDeploy.js's CONTENT_CHOICE — the technician's
// per-requirement choice (AC6) when a matched location's contents differ from the definition.
export const NAMED_LOCATION_CONTENT_CHOICE = {
  ADOPT_AS_IS: 'adoptAsIs',
  UPDATE_TO_DEFINITION: 'updateToDefinition',
}
